<template>
  <div class="create-user">
    <div
      class="create-user__title title"
    >
      {{ modalTitle }}
    </div>
    <div class="section">
      <div>
        <div v-if="!isDataFetched" class="loader">
          <base-loader/>
        </div>
        <template v-else>
          <div class="permissions-row">
            <base-select
              @change="updateUserRole"
              v-model="selectedRole"
              :border-less="true"
              class="create-user__user-type permissions-header-column agency-selector"
              :options="roleOpts"
              :align-left="true"
              :max-height-list="450"
              :title-style="titleStyle"
              :header-style="selectTypeStyle"
            />
          </div>
          <div class="permissions-row">
            <div class="permissions-projects-container">
              <div class="projects-table">
                <div class="table-row table-row__header row-stripe">
                  <div class="table-row__column">Resource</div>
                  <div class="table-row__column">Default Access</div>
                  <div class="table-row__column">User Access</div>
                </div>
                <div v-for="(resource, i) in resources" :class="getTableRowClasses(resource)" class="table-row row-stripe" :key="i">
                  <div class="table-row__column">
                    {{ resource.resource }}
                  </div>
                  <div class="table-row__column">
                    <!-- {{ resource.defaultAccess }} -->
                    <base-check-box
                      v-model="resource.defaultAccess"
                      class="login__form_remember-me"
                      :disabled="true"
                    />
                  </div>
                  <div class="table-row__column">
                    <!-- {{ resource.userAccess }} -->
                    <base-check-box
                      v-model="resource.userAccess"
                      class="login__form_remember-me"
                      @change="updateUserPermission(resource)"
                      :disabled="isAgencyAdmin"
                      v-tooltip.top-start="tooltipContent"
                      />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div class="create-user__controls controls">
        <button
          class="create-user__button cancel button"
          @click.prevent="close()"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import _ from 'lodash'
import moment from 'moment'
import BaseModalMixins from '@/common/BaseModalMixins'
import EditPermissions from './EditPermissions'

const SELECT_STYLE = {
  'background-color': 'transparent',
  color: '#284aff',
  'text-decoration': 'underline'
}
export default {
  name: 'EditPermissions',
  mixins: [BaseModalMixins],
  props: {
    isAgencyAdmin: {
      type: Boolean
    },
    selectedUser: {
      type: Object
    },
    selectedUserPermissions: {
      type: Object
    },
    agencyRoutes: {
      type: Array
    },
    roleRoutes: {
      type: Object
    },
    selectedProject: {
      type: Object
    }
  },
  data () {
    return {
      permissions: [],
      userRoutes: null,
      selectedTab: 'userInfo',
      tabs: {
        userInfo: 'userInfo',
        permissions: 'permissions',
      },
      // should domain name selector be hidden or not
      titleStyle: {
        overflow: 'visible'
      },
      selectedAgency: null,
      permissionData: {},
      isDataFetched: true,
      agencyOpts: [],
      selectedRole: null,
      // originalRole: null,
      activeOpts: [
        {
          label: 'Yes',
          value: true
        },
        {
          label: 'No',
          value: false
        }
      ],
      selectTypeStyle: _.cloneDeep(SELECT_STYLE)
    }
  },
  watch: {
  },
  async mounted () {
    // this.originalRole = this.selectedProject.role_group_id
    // this.selectedRole = this.originalRole ?? this.roles.find(role => role.label === 'Project Member')._id
    this.selectedRole = this.selectedProject.role_group_id ?? this.roles.find(role => role.label === 'Project Member')._id
    if (this.selectedProject.role_group_id) {
      this.isDataFetched = false
      this.userRoutes = await this.getUserRoutes({ projectId: this.selectedProject.project_id, userId: this.selectedUser._id })
      this.isDataFetched = true
    }
  },
  computed: {
    ...mapState(['agencies', 'roles']),
    tooltipContent () {
      const options = {
        delay: { show: 100, hide: 100 },
        classes: 'rfx-tooltip',
        content: 'Admin cannot be restricted'
      }
      if (this.isAgencyAdmin) {
        return options
      }
    },
    modalTitle () {
      return `${this.selectedProject.project_name} > ${this.selectedUser.first_name} ${this.selectedUser.last_name}`
    },
    resources () {
      return this.agencyRoutes.map(route => {
        const permission = {
          // resource: route,
          ...route,
          // defaultAccess: this.roleRoutes[this.selectedRole]?.includes(route) ?? false,
        }
        permission.defaultAccess = this.roleRoutes[this.selectedRole]?.map(route => route.id).includes(route.id) ?? false
        // permission.userAccess = this.selectedRole === this.originalRole ? this.userRoutes?.includes(route.resource) ?? false : permission.defaultAccess
        permission.userAccess = this.isAgencyAdmin ? true : this.userRoutes?.includes(route.resource) ?? permission.defaultAccess

        return permission
      })
    },
    roleOpts () {
      return this.roles.filter(role => role.label !== 'Agency Admin').map(role => {
        return {
          label: role.label,
          value: role._id
        }
      })
    }
  },
  methods: {
    ...mapActions('userManager', ['getUserPermissions', 'getUserRoutes', 'updateProjectRole', 'updateProjectPermission']),
    getTableRowClasses (resource) {
      if (resource.defaultAccess && !resource.userAccess) {
        return 'table-row-restricted'
      } else if (!resource.defaultAccess && resource.userAccess) {
        return 'table-row-allowed'
      }
      return ''
    },
    async updateUserPermission (resource) {
      if (this.isAgencyAdmin) return
      this.$forceUpdate()
      this.dataIsUpdating = true
      await this.updateProjectPermission({
        userId: this.selectedUser._id,
        projectId: this.selectedProject.project_id,
        resourceId: resource.id,
        allow: resource.userAccess
      })
      this.dataIsUpdating = false
    },
    async updateUserRole () {
      this.userRoutes = null
      this.dataIsUpdating = true
      await this.updateProjectRole({
        userId: this.selectedUser._id,
        projectId: this.selectedProject.project_id,
        roleId: this.selectedRole
      })
      this.dataIsUpdating = false
      this.$emit('roleUpdated', this.selectedProject.project_id, this.selectedRole)
    },
    close () {
      this.$emit('cancel')
    },
  }
}
</script>

<style lang="scss" scoped>
.table-row-restricted {
  background-color: $rfx-light-red !important;
}
.table-row-allowed {
  background-color: $rfx-light-green !important;
}
.create-user {
  // display: flex;
  // flex-direction: column;
  // align-items: stretch;
  padding: 40px;
}

.title {
text-align: center;
font-size: 34px;
font-weight: 500;
margin: 9px 0 35px;
color: $rfx-dark-march;
}

.input {
display: flex;
flex-direction: column;
position: relative;
margin-top: 30px;

.invalid[type='text'] {
    border: 1px solid $rfx-red;
    border-radius: 4px;
}
}

.label {
margin-top: 20px;
display: block;
font-weight: 600;
margin-bottom: 5px;
color: $rfx-dark-march;
}

.controls {
display: flex;
justify-content: flex-end;
margin-top: 20px;
}

.button {
width: 100px;
height: 40px;
border-radius: 4px;
font-size: 10px;
font-weight: 900;
text-transform: uppercase;
margin-left: 30px;
border: none;
outline: none;
cursor: pointer;

&.submit {
    background-color: $rfx-medium-march;
    color: #fff;

    &:disabled {
    pointer-events: none;
    background-color: #fff;
    color: $rfx-neutral-grey;
    cursor: default;
    }
}

&.delete {
    background-color: $rfx-red;
    color: #fff
}

&.disabled {
    pointer-events: none;
    background-color: #fff;
    color: $rfx-neutral-grey;
    cursor: default;
}

&.cancel {
    color: $rfx-dark-march;
    background-color: #fff;
}
}

.user {
&-wrapper {
    position: relative;
    margin-top: 30px;

    &_single {
    margin-top: 0;
    }
}

.field[type='text'] {
    width: 100%;
    box-sizing: border-box;
    // padding-right: 60px;
    font-weight: 500;
    @include ellipsis;
}
}

.error-message {
color: $rfx-red;
font-size: 10px;
margin-top: 5px;
}

.date-wrapper {
display: flex;
font-weight: bold;
}

.date {
flex: 0 0 30%;
color: $rfx-dark-march;

.error {
    color: $rfx-red;
}
}

.form-control {
  width: 100%;
  width: -moz-available;
  width: -webkit-fill-available;
  width: stretch;
  height: 50px;
  // padding: 0 20px;
  border: 2px solid $rfx-light-steel;
  outline: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  color: $rfx-dark-march;
  display: inline-block;
  line-height: 50px;
  margin-top: 5px;

  &::placeholder {
    color: $rfx-pearl;
    font-weight: normal;
    font-size: 14px;
  }

  &:disabled {
    background-color: $rfx-light-steel;
  }

  &_error {
    border-color: $rfx-red;
    color: $rfx-red;

    &::placeholder {
      color: $rfx-red;
      font-size: 13px;
    }

  }
}

.section {
  display: flex;
  flex-direction: column;
  // background-color: $rfx-grey;
  border-radius: 5px;
}

.permissions-row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.plan-span {
  flex-grow: 1;
}
.agency-selector {
  width: 30%;
}
.permissions-label {
  height: 50px;
  // padding: 0 20px;
  border: none;
  outline: none;
  font-size: 14px;
  font-weight: 600;
  color: $rfx-dark-march;
  display: block;
  line-height: 50px;
}

.permissions-radio-container {
  display: flex;
}
.permissions-radio {
  cursor: pointer;
}

.tab-content {
  border: 1px solid $rfx-light-steel;
  padding: 0 20px;
  height: 65vh;
  overflow-y: auto;
}

.tabs {
  cursor: pointer;
  display: flex;
  margin-bottom: -1px;

  &_tab {
    width: max-content;
    padding: 16px 9px;
    text-align: center;
    font-size: 14px;
    color: $rfx-light-march;
    background-color: transparent;
    border: 1px solid transparent;
    text-decoration: none;

    &_error {
      color: $rfx-red;
    }

    &_active {
      background-color: #fff;
      color: $rfx-dark-march;
      font-weight: bold;
      border: 1px solid $rfx-light-steel;
      border-bottom: 1px solid #fff;
      z-index: 1;
    }
  }
}
.loader {
    z-index: 1;
    display: flex;
    // position: fixed;
    padding-top: 20vh;
    width: 100%;
    justify-content: center;
    align-items: flex-start;
    height: 100vh;
    background-color: rgba(255, 255, 255, .7);
}

.permissions-projects-container {
  margin-top: 10px;
  width: 100%;
}
.projects-table {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  // border: 1px solid $rfx-light-steel;
}
.row-stripe:nth-child(odd) { 
  background: $rfx-light-steel;
}
.table-row {
  display: flex;
  font-size: 14px;
  border-radius: 4px;
  height: 40px;
  line-height: 40px;
  padding: 0 20px;
  &__header {
    font-weight: 600;
  }
  &__column {
    width: 50%;
  }
}
</style>
